import * as types from './types';
import { AccountingSettingsService } from '../../services/accounting-settings.service';
import { MHTTPCL, JSON_STRING, HttpClient } from '../../../../services/http/http-client';
import { SETTINGS_URL, MODIFICATION_URL } from '../../../../services/common-urls';
import { LoadingUI } from '../../../../plugins/loading/loading';

export const accountingSettingsActions = {
  async [types.AccountingSettingsData.FETCH.ALL]({ commit, getters }, payload) {
    const accountingSettingsData = await MHTTPCL.mergeRequests([
      AccountingSettingsService.findAccountingTabDetails(),
      AccountingSettingsService.findTaxTabDetails(),
      AccountingSettingsService.euOneStopTaxesTab(),
      AccountingSettingsService.getFormatsWithVatCategory()
    ]);
    console.log("::::accountingSettingsData",accountingSettingsData);
    commit(types.AccountingSettingsData.SET.ALL, accountingSettingsData);
  },
  async [types.MoneyAccounts.INSERT.SINGLE]({ commit, getters }, payload) {
    const { money_account_name,
      money_account_holder,
      account_no,
      bank_name,
      sort_code,
      swift,
      iban,
      bank_address } = payload;

    const newMoneyAccount = await MHTTPCL.post(SETTINGS_URL, {
      section: 'settings',
      action: 'save_money_account',
      money_account_name,
      money_account_holder,
      account_no,
      bank_name,
      sort_code,
      swift,
      iban,
      bank_address,
      output: JSON_STRING
    });
    commit(types.AccountingSettingsData.SET.ALL, {
      ...getters.accountingSettingsData,
      money_accounts: newMoneyAccount.data.money_accounts
    });
  },
  async [types.MoneyAccounts.UPDATE.SINGLE]({ dispatch }, payload) {
    const {
      money_account_id,
      money_account_name,
      money_account_holder,
      account_no,
      bank_name,
      sort_code,
      swift,
      iban,
      bank_address,
    } = payload;

    const updatedMoneyAccount = await MHTTPCL.post(MODIFICATION_URL, {
      modify_type: 'record',
      table: 'money_accounts',
      kVal: money_account_id,
      money_account_name,
      money_account_holder,
      account_no,
      bank_name,
      sort_code,
      swift,
      iban,
      bank_address,
    });
    dispatch(types.MoneyAccounts.FETCH.ALL);
  },
  async [types.MoneyAccounts.FETCH.ALL]({ commit, getters }, payload) {
    const moneyAccounts = await MHTTPCL.post(SETTINGS_URL, {
      section: 'settings',
      action: 'load_money_accounts',
      output: JSON_STRING,
    });
    commit(types.AccountingSettingsData.SET.ALL, {
      ...getters.accountingSettingsData,
      money_accounts: moneyAccounts.data.money_accounts
    });
  },
  async [types.MoneyAccounts.DELETE.SINGLE]({ commit, getters }, payload) {
    const { money_account_id } = payload;

    commit(types.AccountingSettingsData.SET.ALL, {
      ...getters.accountingSettingsData,
      money_accounts: getters.accountingSettingsData.money_accounts.
        filter(ma => ma.money_account_id != money_account_id)
    });

    const deletedMoneyAccount = await HttpClient.post(SETTINGS_URL, {
      section: 'settings',
      action: 'remove_money_account',
      money_account_id
    });
  },
  /** Create Cost Group */
  async [types.CostGroups.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    const {
      cost_group_name,
      target,
      cg_type ,
      advance_flag
    } = payload;

    if (!cg_type) {
      throw Error('Provide a Cost Group Type');
    }
    console.log({
      cost_group_name,
      target,
      cg_type ,
      advance_flag
    },`{
      cost_group_name,
      target,
      cg_type ,
      advance_flag
    }`);
    commit(types.AccountingSettingsData.SET.ALL, {
      ...getters.accountingSettingsData,
      [cg_type]: [
        ...getters.accountingSettingsData[cg_type],
        { cost_group_name, target, cost_group_id: Number.MAX_SAFE_INTEGER },
      ]
    });

    const newCostGroup = await HttpClient.post(SETTINGS_URL, {
      section: 'settings',
      action: 'add_cost_group',
      income_flag: cg_type == 'income_groups' ? '1' : '',
      cost_group_name,
      target,
      advance_flag,
    });
    dispatch(types.CostGroups.FETCH.ALL, { cg_type });
  },
  async [types.CostGroups.FETCH.ALL]({ commit, getters }, payload) {
    const { cg_type } = payload;

    if (!cg_type) {
      throw Error('Provide a Cost Group Type');
    }

    const action = cg_type == 'cost_groups' ? 'load_all_cost_groups' : 'load_all_income_groups';

    const allCostGroups = await HttpClient.post(SETTINGS_URL, {
      section: 'settings',
      action: action,
      output: JSON_STRING,
    });
    commit(types.AccountingSettingsData.SET.ALL, {
      ...getters.accountingSettingsData,
      [cg_type]: allCostGroups.data[cg_type],
    });
  },
  async [types.CostGroups.UPDATE.SINGLE]({ commit, getters }, payload) {
    const { name, value, item, cg_type } = payload;
    const { cost_group_id } = item;

    if (!cg_type) {
      throw Error('Provide a Cost Group Type');
    }

    commit(types.AccountingSettingsData.SET.ALL, {
      ...getters.accountingSettingsData,
      [cg_type]: getters.accountingSettingsData[cg_type].
        map(c => {
          if (c.cost_group_id == cost_group_id) {
            return {
              ...c,
              [name]: value,
            };
          } else {
            return c;
          }
        })
    });

    const updatedCostGroup = await HttpClient.post(MODIFICATION_URL, {
      kVal: cost_group_id,
      name,
      value,
      table: 'cost_groups',
      modify_type: '',
      json_op: '',
      json_key: '',
    });
  },
  async [types.CostGroups.UPDATE.ALL]({ dispatch,commit, getters }, payload) {
    const { cost_group_id,name, value, cg_type,target,advance_flag,cost_group_name } = payload;

    if (!cg_type) {
      throw Error('Provide a Cost Group Type');
    }
    const newCostGroup = await HttpClient.post(SETTINGS_URL, {
      section: 'settings',
      action: 'add_edit_cost_group',
      ...payload,
      income_flag: cg_type == 'income_groups' ? '1' : '',
      cost_group_name,
      target,
      advance_flag,
      cost_group_id,
   
    });
    dispatch(types.CostGroups.FETCH.ALL, { cg_type });
  },
  async [types.CostGroups.SET.SINGLE]({ commit, getters }, payload) {
    const {
      cost_group_id,
      cost_group_name,
      target,
      cg_type } = payload;

    if (!cg_type) {
      throw Error('Provide a Cost Group Type');
    }

    commit(types.AccountingSettingsData.SET.ALL, {
      ...getters.accountingSettingsData,
      [cg_type]: getters.accountingSettingsData[cg_type].
        map(c => {
          if (c.cost_group_id == cost_group_id) {
            return {
              ...c,
              cost_group_name,
              target,
            };
          } else {
            return c;
          }
        })
    });

    const setCostGroup = await HttpClient.post(MODIFICATION_URL, {
      modify_type: 'record',
      table: 'cost_groups',
      kVal: cost_group_id,
      cost_group_name,
      target,
    })
  },
  async [types.CostGroups.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const { cost_group_id, cg_type } = payload;

    if (!cg_type) {
      throw Error('Provide a Cost Group Type');
    }

    commit(types.AccountingSettingsData.SET.ALL, {
      ...getters.accountingSettingsData,
      [cg_type]: getters.accountingSettingsData[cg_type].
        filter(c => c.cost_group_id != cost_group_id)
    });

    const deletedCostGroup = await HttpClient.post(SETTINGS_URL, {
      section: 'settings',
      action: 'remove_cost_group',
      cost_group_id
    });
  },

  async [types.Channels.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    const {
      channel_name,
      identifier
    } = payload;

    commit(types.AccountingSettingsData.SET.ALL, {
      ...getters.accountingSettingsData,
      channels: [
        ...getters.accountingSettingsData.channels,
        { channel_name, identifier, channel_id: Number.MAX_SAFE_INTEGER },
      ]
    });

    const newChannel = await HttpClient.post(SETTINGS_URL, {
      section: 'settings',
      action: 'add_channel',
      channel_name,
      identifier,
    });

    dispatch(types.Channels.FETCH.ALL);
  },
  async [types.Channels.FETCH.ALL]({ commit, getters }, payload) {
    const allChannels = await HttpClient.post(SETTINGS_URL, {
      section: 'settings',
      action: 'load_channels',
      output: JSON_STRING,
    });

    commit(types.AccountingSettingsData.SET.ALL, {
      ...getters.accountingSettingsData,
      channels: allChannels.data.channels,
    });
  },
  async [types.Channels.UPDATE.SINGLE]({ commit, getters }, payload) {
    const {
      channel_id,
      channel_name,
      identifier,
    } = payload;

    commit(types.AccountingSettingsData.SET.ALL, {
      ...getters.accountingSettingsData,
      channels: getters.accountingSettingsData.channels.
        map(channel => {
          if (channel.channel_id == channel_id) {
            return {
              ...channel,
              channel_name,
              identifier,
            };
          } else {
            return channel;
          }
        })
    });

    const updatedChannel = await HttpClient.post(MODIFICATION_URL, {
      modify_type: 'record',
      table: 'channels',
      kVal: channel_id,
      channel_name,
      identifier,
    })
  },
  async [types.Channels.DELETE.SINGLE]({ commit, getters }, payload) {
    const { channel_id } = payload;

    commit(types.AccountingSettingsData.SET.ALL, {
      ...getters.accountingSettingsData,
      channels: getters.accountingSettingsData.channels.
        filter(c => c.channel_id != channel_id)
    });

    const deletedChannel = await HttpClient.post(SETTINGS_URL, {
      section: 'settings',
      action: 'remove_channel',
      channel_id
    })
  },


  // Tax Type Actions
  async [types.TaxTypes.INSERT.SINGLE] ({commit, getters, dispatch}, payload) {
    const {
      tax_name,
      tax_description,
      tax_rate_percent,
      tax_deduction_flag,
      vat_type,
    } = payload;
    
    commit(types.AccountingSettingsData.SET.ALL, {
      ...getters.accountingSettingsData,
      tax_types: [
        ...getters.accountingSettingsData.tax_types,
        {
          tax_name,
          tax_description,
          tax_rate_percent,
          tax_deduction_flag,
          vat_type,
          tax_type_id: Number.MAX_SAFE_INTEGER
        },
      ]
    });

    const newTaxType = await HttpClient.post(SETTINGS_URL, {
      section: 'settings',
      action: 'save_tax_type',
      tax_name,
      tax_description,
      tax_rate_percent,
      tax_deduction_flag,
      vat_type,
    });
    dispatch(types.TaxTypes.FETCH.ALL);
  },
  async [types.TaxTypes.FETCH.ALL] ({commit, getters}, payload) {
    const taxTypes = await HttpClient.post(SETTINGS_URL, {
      section: 'settings',
      action: 'load_tax_types',
      output: JSON_STRING,
    });
    commit(types.AccountingSettingsData.SET.ALL, {
      ...getters.accountingSettingsData,
      tax_types: taxTypes.data.tax_types
    });
  },
  async [types.TaxTypes.SET.SINGLE] ({commit, getters, dispatch}, payload) {
    const { 
      tax_type_id,
      tax_name,
      tax_description,
      tax_rate_percent,
      tax_deduction_flag,
      vat_type,
    } = payload;

    commit(types.AccountingSettingsData.SET.ALL, {
      ...getters.accountingSettingsData,
      tax_types: getters.accountingSettingsData.tax_types.
        map(t => {
          if (t.tax_type_id == tax_type_id) {
            return {
              ...t,
              tax_name,
              tax_description,
              tax_rate_percent,
              tax_deduction_flag,
              vat_type,
            };
          } else {
            return t;
          }
        })
    });
    
    const savedTaxType = await HttpClient.post(MODIFICATION_URL, {
      modify_type: 'record',
      table: 'tax_types',
      kVal: tax_type_id,
      tax_name,
      tax_description,
      tax_rate_percent,
      tax_deduction_flag,
      vat_type,
    });

    dispatch(types.TaxTypes.FETCH.ALL);
  },
  async [types.TaxTypes.UPDATE.SINGLE] ({commit, getters}, payload) {
    const { item, name, value } = payload;
    const { tax_type_id } = item;
    commit(types.AccountingSettingsData.SET.ALL, {
      ...getters.accountingSettingsData,
      tax_types: getters.accountingSettingsData.tax_types
        .map(t => {
          if (t.tax_type_id == tax_type_id) {
            return {
              ...t,
              [name]: value,
            };
          } else {
            return t;
          }
        })
    });

    const updatedTaxTypes = await HttpClient.post(MODIFICATION_URL, {
      key: 'tax_type_id',
      kVal: tax_type_id,
      table: 'tax_types',
      name,
      value,
    })
  },
  async [types.TaxTypes.DELETE.SINGLE] ({commit, getters}, payload) {
    const { tax_type_id } = payload;
    
    commit(types.AccountingSettingsData.SET.ALL, {
      ...getters.accountingSettingsData,
      tax_types: getters.accountingSettingsData.tax_types.
        filter(t => {
          if (t.tax_type_id == tax_type_id) {
            return false;
          } else {
            return true;
          }
        })
    });

    const deletedTaxTYype = await HttpClient.post(SETTINGS_URL, {
      section: 'settings',
      action: 'remove_tax_type',
      tax_type_id,
    })
  },


  //Tax Group Actions
  async [types.TaxGroups.INSERT.SINGLE]({commit, getters}, payload) {
    const { tax_group_name } = payload;

    commit(types.AccountingSettingsData.SET.ALL, {
      ...getters.accountingSettingsData,
      tax_groups: [
        ...getters.accountingSettingsData.tax_groups,
        { tax_group_name },
      ]
    });
  },
  async [types.TaxGroups.FETCH.ALL]({commit, getters}, payload) {

  },
  async [types.TaxGroups.UPDATE.SINGLE]({commit, getters}, payload) {

  },
  async [types.TaxGroups.DELETE.SINGLE]({commit, getters}, payload) {
    const { tax_group_id, tax_group_name } = payload;
    console.log(payload);
    if (!tax_group_id) {
      commit(types.AccountingSettingsData.SET.ALL, {
        ...getters.accountingSettingsData,
        tax_groups: getters.accountingSettingsData.tax_groups.
          filter(t => t.tax_group_name != tax_group_name)
      });
      return;
    }
    
    commit(types.AccountingSettingsData.SET.ALL, {
      ...getters.accountingSettingsData,
      tax_groups: getters.accountingSettingsData.tax_groups.
        filter(t => t.tax_group_id != tax_group_id)
    });
    
    const deletedTaxGroup = await HttpClient.post(SETTINGS_URL, {
      section: 'settings',
      action: 'delete_tax_group',
      tax_group_id
    });
  },

  // Tax Group Item Actions
  async [types.TaxGroupItems.INSERT.SINGLE] ({commit, getters, dispatch}, payload) {
    const {
      tax_group_id,
      tax_group_name,
      tax_type_id,
    } = payload;


    commit(types.AccountingSettingsData.SET.ALL, {
      ...getters.accountingSettingsData,
      tax_group_items: [
        ...(getters.accountingSettingsData.tax_group_items || []),
        payload,
      ]
    });
    
    const newTaxGroupItem = await HttpClient.post(SETTINGS_URL, {
      section: 'settings',
      action: 'add_tax_relation',
      tax_group_id,
      tax_type_id,
      tax_group_name,
    });


    dispatch(types.TaxGroupItems.FETCH.ALL, { tax_group_name, tax_group_id });
  },
  async [types.TaxGroupItems.FETCH.ALL] ({commit, getters}, payload) {
    const { tax_group_id, tax_group_name } = payload;

    commit(types.AccountingSettingsData.SET.ALL, {
      ...getters.accountingSettingsData,
      tax_group_items_loading: true
    });

    const taxGroupItems = await HttpClient.post(SETTINGS_URL, {
      section: 'settings',
      action: 'get_tax_group_items',
      output: JSON_STRING,
      tax_group_name,
      tax_group_id,
    });

    console.log(taxGroupItems.data);

    commit(types.AccountingSettingsData.SET.ALL, {
      ...getters.accountingSettingsData,
      tax_group_items: taxGroupItems.data.tax_group_items,
      tax_group_items_loading: false
    });
  },
  async [types.TaxGroupItems.UPDATE.SINGLE] ({commit, getters}, UPDATE) {

  },
  async [types.TaxGroupItems.DELETE.SINGLE] ({commit, getters}, payload) {
    const { tax_relation_id } = payload;

    commit(types.AccountingSettingsData.SET.ALL, {
      ...getters.accountingSettingsData,
      tax_group_items: getters.accountingSettingsData.tax_group_items.
        filter(t => t.tax_relation_id != tax_relation_id)
    });
    
    const deletedTaxGroupItem = await HttpClient.post(SETTINGS_URL, {
      section: 'settings',
      action: 'remove_tax_relation',
      tax_relation_id
    });
  },

  async [types.VatProductCategory.DELETE.SINGLE]({commit, getters}, payload){
    
    const { vat_category_id } = payload;

    commit(types.AccountingSettingsData.SET.ALL, {
      ...getters.accountingSettingsData,
      vat_categories: getters.accountingSettingsData.vat_categories.
        filter(t => t.vat_category_id != vat_category_id)
    });
    const deletedConfirm = await AccountingSettingsService.deleteVatCategory(vat_category_id);

  },

  async [types.VatProductCategory.INSERT.MULTIPLE]({commit, getters}, payload){
    
    //const { vat_category_id } = payload;

    commit(types.AccountingSettingsData.SET.ALL, {
      ...getters.accountingSettingsData,
      vat_categories: payload.vat_categories
    });
    //const deletedConfirm = await AccountingSettingsService.deleteVatCategory(vat_category_id);

  },


  async [types.SettingsAccountFormat.UPDATE.SINGLE]({commit, getters}, payload){
    
    const { name , text, value , item } = payload;

    commit(types.AccountingSettingsData.SET.ALL, {
      ...getters.accountingSettingsData,
      formats: getters.accountingSettingsData.formats.
        map(e=>{
          if(e.format_id==item.format_id){
            return{
              ...e,
              vat_category_id:value,
              vat_category_name:text
            }
          }else{
            return e;
          }
        })
    });
    
    const m = await MHTTPCL.modifyJSON(undefined,item.format_id,'vat_category_id',value,'l_formats');

  },
  async [types.SettingsAccountVatTerritory.INSERT.SINGLE]({commit, getters}, payload){
    
    //const { vat_category_id } = payload;

    const resData = await AccountingSettingsService.saveVatTterritory({...payload})

    commit(types.AccountingSettingsData.SET.ALL, {
      ...getters.accountingSettingsData,
      vat_territories: resData.data.vat_territories
    });
   

  },

  async [types.SettingsAccountVatTerritory.DELETE.SINGLE]({commit, getters}, payload){
    
    const { vat_territory_id } = payload;

    commit(types.AccountingSettingsData.SET.ALL, {
      ...getters.accountingSettingsData,
      vat_territories: getters.accountingSettingsData.vat_territories.
        filter(t => t.vat_territory_id != vat_territory_id)
    });
    const deletedConfirm = await AccountingSettingsService.deleteVatTerritory(vat_territory_id);

  },
}
